module.exports = __webpack_public_path__ + "media/images/soar/comments_wifi2-1970f2a5aa37946290e477097fe1c1fd.png";